import { Directive, HostListener, Input, OnDestroy, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Guid } from "guid-typescript";
import { DirtyTrackingService } from "./dirty-tracking.service";

@Directive({
  selector: 'dirty-tracking',
  inputs: ['forms'],
})
export class DirtyTrackingDirective implements OnInit, OnDestroy {
  @Input('forms') forms!: NgForm[];

  private ids: Guid[];
  constructor(private dirtyService: DirtyTrackingService) {

  }

  ngOnDestroy(): void {
    this.dirtyService.clearForms(this.ids);
  }

  ngOnInit(): void {
    this.ids = this.dirtyService.registerForms(this.forms);
  }
}